// Public camp STAFF application form client. Vanilla ES served as a static
// asset (no bundler, no imports) — matches the convention of the sibling
// external apps.
//
// Phase 3b.2 – 3b.4 scope: full form UI + submit pipeline + avatar upload.
//   - Gender gate: applicant picks male/female before the rest of the form
//     becomes visible. Dynamic questions are re-rendered when gender changes.
//   - Populates the positions dropdown from admin config.
//   - Renders session-preference checkboxes.
//   - Renders dynamic questions filtered by bundle.questions[].gender
//     (shows 'both' + whichever gender the applicant chose).
//   - Renders 2 reference sub-forms from a template.
//   - Client-side validation.
//   - Optional avatar upload with preview (blob URL).
//   - POST /:token as multipart (payload JSON + avatar file);
//     swaps the page for a thank-you panel on success.
(function () {
  "use strict";

  var bundle = readJSON("bundle-json");
  // token used by the Phase 3b.3 submit handler; referenced via window to
  // avoid an "unused variable" warning in strict builds.
  window.__campStaffForm = { token: readJSON("token-json") };

  if (!bundle || !bundle.summer) {
    // Defensive: the server should have already rendered 404 in this case.
    return;
  }

  var genderGate = document.getElementById("gender-gate");
  var form = document.getElementById("staff-form");
  var genderInput = document.getElementById("gender-input");
  var genderLabel = document.getElementById("gender-label");
  var changeGenderBtn = document.getElementById("change-gender-btn");
  var positionSelect = document.getElementById("position-select");
  var sessionsContainer = document.getElementById("sessions-container");
  var questionsPanel = document.getElementById("questions-panel");
  var questionsContainer = document.getElementById("questions-container");
  var referencesContainer = document.getElementById("references-container");
  var submitBtn = document.getElementById("submit-btn");
  var submitHint = document.getElementById("submit-hint");
  var submitError = document.getElementById("submit-error");
  var avatarInput = document.getElementById("avatar-input");
  var avatarPreview = document.getElementById("avatar-preview");
  var avatarRemoveBtn = document.getElementById("avatar-remove-btn");
  var avatarError = document.getElementById("avatar-error");

  // Currently-selected avatar file (File object) + its blob URL for preview.
  // Cleared via `clearAvatar()` which revokes the URL to avoid leaking.
  var avatarState = { file: null, previewUrl: null };
  var AVATAR_MAX_BYTES = 10 * 1024 * 1024;
  var AVATAR_ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];

  // ----------------------------------------------------------------
  // Utilities
  // ----------------------------------------------------------------

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatDate(iso) {
    if (!iso) return "";
    var parts = String(iso).split("-");
    if (parts.length !== 3) return iso;
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var m = months[parseInt(parts[1], 10) - 1] || "";
    return parseInt(parts[2], 10) + " " + m + " " + parts[0];
  }

  function escapeHtml(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function populateOptions(select, items) {
    (items || []).forEach(function (item) {
      var value = typeof item === "string" ? item : (item && (item.label || item.name));
      if (!value) return;
      var opt = document.createElement("option");
      opt.value = value;
      opt.textContent = value;
      select.appendChild(opt);
    });
  }

  // ----------------------------------------------------------------
  // Gender gate
  // ----------------------------------------------------------------

  function chooseGender(gender) {
    if (gender !== "male" && gender !== "female") return;
    genderInput.value = gender;
    genderLabel.textContent = gender === "male" ? "boys camp" : "girls camp";
    genderGate.hidden = true;
    form.hidden = false;
    renderQuestions(gender);
    window.scrollTo(0, 0);
  }

  function showGenderGate() {
    genderInput.value = "";
    genderGate.hidden = false;
    form.hidden = true;
    window.scrollTo(0, 0);
  }

  Array.from(document.querySelectorAll("[data-gender-choice]")).forEach(function (btn) {
    btn.addEventListener("click", function () {
      chooseGender(btn.getAttribute("data-gender-choice"));
    });
  });

  if (changeGenderBtn) {
    changeGenderBtn.addEventListener("click", showGenderGate);
  }

  // ----------------------------------------------------------------
  // Sessions
  // ----------------------------------------------------------------

  function renderSessions() {
    (bundle.sessions || []).forEach(function (s) {
      var row = document.createElement("label");
      row.className = "session-row";
      var dates = "";
      if (s.start_date && s.end_date) {
        dates = formatDate(s.start_date) + " – " + formatDate(s.end_date);
      } else if (s.start_date) {
        dates = formatDate(s.start_date);
      }
      row.innerHTML =
        '<input type="checkbox" data-session-id="' + escapeHtml(s.id) + '">' +
        '<span class="session-name">' + escapeHtml(s.name) + '</span>' +
        (dates ? '<span class="session-dates">' + escapeHtml(dates) + '</span>' : "");
      sessionsContainer.appendChild(row);
    });
  }

  // ----------------------------------------------------------------
  // Dynamic questions — filtered by gender
  //
  // We keep any existing answers when re-rendering so changing gender
  // mid-form doesn't wipe the user's typing for shared ('both') questions.
  // ----------------------------------------------------------------

  function captureAnswers() {
    var answers = {};
    questionsContainer.querySelectorAll("[data-question]").forEach(function (card) {
      var id = card.getAttribute("data-question-id");
      var input = card.querySelector("[data-question-input]");
      if (id && input) answers[id] = input.value;
    });
    return answers;
  }

  function renderQuestions(gender) {
    var previous = captureAnswers();
    var template = document.getElementById("question-template");
    questionsContainer.innerHTML = "";

    var questions = (bundle.questions || []).filter(function (q) {
      return q.gender === "both" || q.gender === gender;
    });

    if (!questions.length) {
      questionsPanel.hidden = true;
      return;
    }

    questionsPanel.hidden = false;
    questions.forEach(function (q) {
      var node = template.content.firstElementChild.cloneNode(true);
      node.setAttribute("data-question-id", q.id);
      node.querySelector(".question-text").textContent = q.question;
      if (q.required) node.querySelector(".required-marker").hidden = false;
      var input = node.querySelector("[data-question-input]");
      input.setAttribute("name", "q_" + q.id);
      if (q.required) input.required = true;
      if (previous[q.id]) input.value = previous[q.id];
      questionsContainer.appendChild(node);
    });
  }

  // ----------------------------------------------------------------
  // Avatar (optional) — client-side validation + preview via blob URL.
  // Server re-validates, re-decodes with sharp and strips EXIF, so this
  // layer is for UX only. Never use file.type as an authoritative signal.
  // ----------------------------------------------------------------

  function showAvatarError(msg) {
    if (!avatarError) return;
    avatarError.textContent = msg || "";
    avatarError.hidden = !msg;
  }

  function clearAvatar() {
    if (avatarState.previewUrl) {
      try { URL.revokeObjectURL(avatarState.previewUrl); } catch (_e) { /* ignore */ }
    }
    avatarState = { file: null, previewUrl: null };
    if (avatarInput) avatarInput.value = "";
    if (avatarPreview) {
      avatarPreview.innerHTML = '<span class="avatar-placeholder">No photo</span>';
      avatarPreview.classList.remove("has-image");
    }
    if (avatarRemoveBtn) avatarRemoveBtn.hidden = true;
    showAvatarError("");
  }

  function setAvatarPreview(file) {
    if (avatarState.previewUrl) {
      try { URL.revokeObjectURL(avatarState.previewUrl); } catch (_e) { /* ignore */ }
    }
    var url = URL.createObjectURL(file);
    avatarState.file = file;
    avatarState.previewUrl = url;
    if (avatarPreview) {
      avatarPreview.innerHTML = "";
      avatarPreview.classList.add("has-image");
      var img = document.createElement("img");
      img.src = url;
      img.alt = "";
      avatarPreview.appendChild(img);
    }
    if (avatarRemoveBtn) avatarRemoveBtn.hidden = false;
  }

  function handleAvatarChange(ev) {
    var file = ev.target.files && ev.target.files[0];
    if (!file) {
      clearAvatar();
      return;
    }
    if (AVATAR_ALLOWED_TYPES.indexOf(file.type) === -1) {
      showAvatarError("Please choose a JPEG, PNG or WebP image.");
      avatarInput.value = "";
      return;
    }
    if (file.size > AVATAR_MAX_BYTES) {
      showAvatarError("That image is too large (max 10MB). Please choose a smaller one.");
      avatarInput.value = "";
      return;
    }
    showAvatarError("");
    setAvatarPreview(file);
  }

  if (avatarInput) avatarInput.addEventListener("change", handleAvatarChange);
  if (avatarRemoveBtn) avatarRemoveBtn.addEventListener("click", clearAvatar);

  // ----------------------------------------------------------------
  // References (always two)
  // ----------------------------------------------------------------

  function renderReferences() {
    var template = document.getElementById("reference-template");
    for (var i = 0; i < 2; i++) {
      var node = template.content.firstElementChild.cloneNode(true);
      node.querySelector("[data-reference-index]").textContent = i + 1;
      referencesContainer.appendChild(node);
    }
  }

  // ----------------------------------------------------------------
  // State readers (used by submit in Phase 3b.3)
  // ----------------------------------------------------------------

  function readFormPayload() {
    function val(name) {
      var el = form.querySelector("[name='" + name + "']");
      return el ? (el.value || "").trim() : "";
    }
    var sessionIds = Array.from(form.querySelectorAll("[data-session-id]:checked"))
      .map(function (cb) { return cb.getAttribute("data-session-id"); });

    var answers = {};
    questionsContainer.querySelectorAll("[data-question]").forEach(function (card) {
      var id = card.getAttribute("data-question-id");
      var input = card.querySelector("[data-question-input]");
      if (id && input) {
        var v = (input.value || "").trim();
        if (v) answers[id] = v;
      }
    });

    var references = Array.from(referencesContainer.querySelectorAll("[data-reference]"))
      .map(function (card) {
        function refVal(f) {
          var el = card.querySelector("[data-ref-field='" + f + "']");
          return el ? (el.value || "").trim() : "";
        }
        return {
          prefix: refVal("prefix"),
          name: refVal("name"),
          title: refVal("title"),
          email: refVal("email"),
          phone: refVal("phone"),
        };
      });

    return {
      gender: val("gender"),
      first_name: val("first_name"),
      last_name: val("last_name"),
      email: val("email"),
      phone: val("phone"),
      dob: val("dob"),
      school: val("school"),
      street: val("street"),
      town: val("town"),
      post_code: val("post_code"),
      position: val("position"),
      camp_history: val("camp_history"),
      session_preferences: sessionIds,
      answers: answers,
      references: references,
    };
  }

  // Loose structural mirror of the server's Joi .email() rule:
  // something@domain.tld with alphanumeric/hyphen domain labels and an
  // alphabetic TLD of 2+ chars. The form is novalidate, so the browser's
  // own type="email" check never runs; without this a typo like
  // "name@gmail" only failed server-side with a generic 400.
  var EMAIL_PATTERN = /^[^\s@]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;

  // Validate the payload AND, as a side effect, mark any offending DOM
  // fields with .is-invalid so the applicant sees red borders next to the
  // actual problem. Returns { message, firstInvalid } so the submit handler
  // can scroll/focus the offending field.
  function validatePayload(p) {
    clearInvalidMarks();

    function markName(name) {
      var el = form.querySelector("[name='" + name + "']");
      if (el) el.classList.add("is-invalid");
      return el;
    }

    if (p.gender !== "male" && p.gender !== "female") {
      return { message: "Please choose an application (boys or girls camp).", firstInvalid: genderGate };
    }

    // Detect "typed something the browser couldn't parse" on the date of
    // birth — Chrome/Edge clear el.value when the date is invalid, so a
    // bad-format entry would otherwise silently submit as empty.
    var dobInput = form.querySelector("[name='dob']");
    if (dobInput && dobInput.validity && dobInput.validity.badInput) {
      dobInput.classList.add("is-invalid");
      return { message: "The date of birth you entered is not valid. Please use the date picker, or type DD/MM/YYYY.", firstInvalid: dobInput };
    }

    if (!p.first_name || !p.last_name) {
      var firstName = !p.first_name ? markName("first_name") : null;
      var lastName = !p.last_name ? markName("last_name") : null;
      return { message: "First and last name are required.", firstInvalid: firstName || lastName };
    }
    if (!p.email) {
      return { message: "Email address is required.", firstInvalid: markName("email") };
    }
    if (!EMAIL_PATTERN.test(p.email)) {
      return { message: "Your email address doesn't look right. Please check it.", firstInvalid: markName("email") };
    }
    // The question bank may mark some questions as required — the required
    // attribute on each textarea covers that; we still check here in case
    // the browser's native check is bypassed.
    var reqFail = null;
    var reqFailEl = null;
    questionsContainer.querySelectorAll("[data-question]").forEach(function (card) {
      if (reqFail) return;
      var input = card.querySelector("[data-question-input]");
      if (input && input.required && !(input.value || "").trim()) {
        var label = card.querySelector(".question-text");
        reqFail = "Please answer: " + (label ? label.textContent : "a required question");
        input.classList.add("is-invalid");
        reqFailEl = input;
      }
    });
    if (reqFail) return { message: reqFail, firstInvalid: reqFailEl };

    for (var i = 0; i < p.references.length; i++) {
      var r = p.references[i];
      var ord = i === 0 ? "first" : "second";
      if (!r.name || !r.email) {
        var refCards = referencesContainer.querySelectorAll("[data-reference]");
        var card = refCards[i];
        var firstRefEl = null;
        if (card) {
          if (!r.name) {
            var nameEl = card.querySelector("[data-ref-field='name']");
            if (nameEl) { nameEl.classList.add("is-invalid"); firstRefEl = nameEl; }
          }
          if (!r.email) {
            var emailEl = card.querySelector("[data-ref-field='email']");
            if (emailEl) {
              emailEl.classList.add("is-invalid");
              if (!firstRefEl) firstRefEl = emailEl;
            }
          }
        }
        return { message: "Please fill in the " + ord + " reference's name and email.", firstInvalid: firstRefEl };
      }
      if (!EMAIL_PATTERN.test(r.email)) {
        var refCardsFmt = referencesContainer.querySelectorAll("[data-reference]");
        var fmtCard = refCardsFmt[i];
        var fmtEmailEl = fmtCard ? fmtCard.querySelector("[data-ref-field='email']") : null;
        if (fmtEmailEl) fmtEmailEl.classList.add("is-invalid");
        return { message: "The " + ord + " reference's email address doesn't look right. Please check it.", firstInvalid: fmtEmailEl };
      }
    }
    return null;
  }

  function clearInvalidMarks() {
    form.querySelectorAll(".is-invalid").forEach(function (el) {
      el.classList.remove("is-invalid");
    });
  }

  // Expose readers so follow-on phases can consume them without reaching
  // into the DOM directly.
  window.__campStaffForm.readFormPayload = readFormPayload;
  window.__campStaffForm.validatePayload = validatePayload;

  function showSubmitError(msg, firstInvalid) {
    submitError.textContent = msg || "";
    submitError.hidden = !msg;
    if (msg) {
      submitError.classList.add("is-prominent");
    } else {
      submitError.classList.remove("is-prominent");
    }
    if (msg && firstInvalid && typeof firstInvalid.scrollIntoView === "function") {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(function () {
        if (typeof firstInvalid.focus === "function") {
          try { firstInvalid.focus({ preventScroll: true }); } catch (_e) { firstInvalid.focus(); }
        }
      }, 250);
    } else if (msg) {
      submitError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function setSubmitting(on) {
    submitBtn.disabled = !!on;
    submitBtn.textContent = on ? "Submitting…" : "Submit application";
  }

  function showThankYou() {
    var main = document.querySelector(".container");
    main.innerHTML =
      '<section class="panel success">' +
      '<h2>Thank you — your application has been submitted.</h2>' +
      '<p>We have received your application. Reference requests have been sent to both of your referees ' +
      "— we can't move forward with the review until they respond, so please let them know to look out for the email.</p>" +
      '<p>You will receive an email confirmation shortly.</p>' +
      "</section>";
  }

  async function handleSubmit(ev) {
    ev.preventDefault();
    showSubmitError("");

    var payload = readFormPayload();
    var clientErr = validatePayload(payload);
    if (clientErr) {
      showSubmitError(clientErr.message, clientErr.firstInvalid);
      return;
    }

    setSubmitting(true);
    try {
      var token = window.__campStaffForm.token;
      // multipart/form-data — payload JSON goes in one field, avatar (if
      // chosen) as a file field. Do NOT set Content-Type manually; the
      // browser adds the correct multipart boundary.
      var fd = new FormData();
      fd.append("payload", JSON.stringify(payload));
      if (avatarState.file) {
        fd.append("avatar", avatarState.file);
      }
      var resp = await fetch("/" + encodeURIComponent(token), {
        method: "POST",
        body: fd,
      });
      var body = null;
      try { body = await resp.json(); } catch (_e) { /* non-json 500 */ }
      if (!resp.ok || !body || body.ok !== true) {
        showSubmitError((body && body.error) || "Submission failed. Please try again.");
        setSubmitting(false);
        return;
      }
      window.scrollTo(0, 0);
      showThankYou();
    } catch (err) {
      showSubmitError("Network error. Please check your connection and try again.");
      setSubmitting(false);
    }
  }

  if (form && submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = "Submit application";
    if (submitHint) submitHint.hidden = true;
    form.addEventListener("submit", handleSubmit);

    // Clear the red .is-invalid highlight as soon as the applicant edits
    // the field, so they get immediate feedback that they've addressed it.
    form.addEventListener("input", function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("is-invalid")) {
        e.target.classList.remove("is-invalid");
      }
    });
    form.addEventListener("change", function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("is-invalid")) {
        e.target.classList.remove("is-invalid");
      }
    });
  }

  // ----------------------------------------------------------------
  // Boot
  // ----------------------------------------------------------------

  populateOptions(positionSelect, bundle.positions);
  renderSessions();
  renderReferences();
})();
